/* eslint-disable */
import React from 'react';

export type MisconceptionCardIconRender = (active: boolean) => React.ReactNode;

export const HCG_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 18L18 30M18 18L30 30M15.72 4H32.28L44 15.72V32.28L32.28 44H15.72L4 32.28V15.72L15.72 4Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.0799 12.84C44.8423 11.8908 44.3585 11.0211 43.6772 10.3188C42.996 9.61648 42.1414 9.10637 41.1999 8.84C37.7599 8 23.9999 8 23.9999 8C23.9999 8 10.2399 8 6.79992 8.92C5.85842 9.18637 5.00388 9.69648 4.32262 10.3988C3.64135 11.1011 3.1575 11.9708 2.91992 12.92C2.29035 16.4111 1.98239 19.9526 1.99992 23.5C1.97748 27.0741 2.28546 30.6426 2.91992 34.16C3.18184 35.0797 3.67654 35.9163 4.35621 36.589C5.03589 37.2616 5.87756 37.7476 6.79992 38C10.2399 38.92 23.9999 38.92 23.9999 38.92C23.9999 38.92 37.7599 38.92 41.1999 38C42.1414 37.7336 42.996 37.2235 43.6772 36.5212C44.3585 35.8189 44.8423 34.9492 45.0799 34C45.7046 30.5352 46.0126 27.0207 45.9999 23.5C46.0224 19.9259 45.7144 16.3574 45.0799 12.84Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4999 30.04L30.9999 23.5L19.4999 16.96V30.04Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 32C15.9706 32 20 27.9706 20 23C20 18.0294 15.9706 14 11 14C6.02944 14 2 18.0294 2 23C2 27.9706 6.02944 32 11 32ZM11 32H37M37 32C41.9706 32 46 27.9706 46 23C46 18.0294 41.9706 14 37 14C32.0294 14 28 18.0294 28 23C28 27.9706 32.0294 32 37 32Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.58 7.71992L3.64004 35.9999C3.29078 36.6048 3.10598 37.2905 3.10402 37.989C3.10206 38.6874 3.28302 39.3742 3.62889 39.981C3.97477 40.5878 4.47349 41.0934 5.07546 41.4476C5.67742 41.8018 6.36164 41.9922 7.06004 41.9999H40.94C41.6384 41.9922 42.3227 41.8018 42.9246 41.4476C43.5266 41.0934 44.0253 40.5878 44.3712 39.981C44.7171 39.3742 44.898 38.6874 44.8961 37.989C44.8941 37.2905 44.7093 36.6048 44.36 35.9999L27.42 7.71992C27.0635 7.13213 26.5615 6.64616 25.9624 6.30889C25.3634 5.97162 24.6875 5.79443 24 5.79443C23.3126 5.79443 22.6367 5.97162 22.0377 6.30889C21.4386 6.64616 20.9366 7.13213 20.58 7.71992Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const MC_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39 15L66 36L39 57L39 15Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00001 15L33 36L6.00001 57L6.00001 15Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60 12L24.36 47.64M43.41 43.44L60 60M24.36 24.36L36 36M27 18C27 22.9706 22.9706 27 18 27C13.0294 27 9 22.9706 9 18C9 13.0294 13.0294 9 18 9C22.9706 9 27 13.0294 27 18ZM27 54C27 58.9706 22.9706 63 18 63C13.0294 63 9 58.9706 9 54C9 49.0294 13.0294 45 18 45C22.9706 45 27 49.0294 27 54Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63 24V9H48M63 9L12 60M48 63H63V48M63 63L45 45M12 12L27 27"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 45C12 45 15 42 24 42C33 42 39 48 48 48C57 48 60 45 60 45V9C60 9 57 12 48 12C39 12 33 6 24 6C15 6 12 9 12 9V45ZM12 45V66"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const FCG_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 27V6H54V27M18 54H12C10.4087 54 8.88258 53.3679 7.75736 52.2426C6.63214 51.1174 6 49.5913 6 48V33C6 31.4087 6.63214 29.8826 7.75736 28.7574C8.88258 27.6321 10.4087 27 12 27H60C61.5913 27 63.1174 27.6321 64.2426 28.7574C65.3679 29.8826 66 31.4087 66 33V48C66 49.5913 65.3679 51.1174 64.2426 52.2426C63.1174 53.3679 61.5913 54 60 54H54M18 42H54V66H18V42Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6L49.5 16.5L54 39L39 54L16.5 49.5L6 6ZM6 6L28.758 28.758M36 57L57 36L66 45L45 66L36 57ZM39 33C39 36.3137 36.3137 39 33 39C29.6863 39 27 36.3137 27 33C27 29.6863 29.6863 27 33 27C36.3137 27 39 29.6863 39 33Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57 15L15 57M27 19.5C27 23.6421 23.6421 27 19.5 27C15.3579 27 12 23.6421 12 19.5C12 15.3579 15.3579 12 19.5 12C23.6421 12 27 15.3579 27 19.5ZM60 52.5C60 56.6421 56.6421 60 52.5 60C48.3579 60 45 56.6421 45 52.5C45 48.3579 48.3579 45 52.5 45C56.6421 45 60 48.3579 60 52.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63 34.5001C63.0103 38.4597 62.0852 42.3657 60.3 45.9001C58.1833 50.1353 54.9293 53.6976 50.9023 56.1879C46.8754 58.6782 42.2347 59.9983 37.5 60.0001C33.5404 60.0104 29.6343 59.0853 26.1 57.3001L9 63.0001L14.7 45.9001C12.9148 42.3657 11.9897 38.4597 12 34.5001C12.0018 29.7654 13.3218 25.1246 15.8122 21.0977C18.3025 17.0708 21.8648 13.8168 26.1 11.7001C29.6343 9.91488 33.5404 8.98976 37.5 9.00009H39C45.253 9.34506 51.1591 11.9844 55.5874 16.4127C60.0157 20.841 62.655 26.747 63 33.0001V34.5001Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const HCG_Section3_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.42 31.78C41.1476 34.789 39.1575 37.4404 36.6237 39.5026C34.0899 41.5648 31.0895 42.9749 27.8848 43.6096C24.6802 44.2443 21.3688 44.0843 18.2402 43.1436C15.1117 42.2029 12.2612 40.5101 9.93799 38.2133C7.61478 35.9165 5.88958 33.0855 4.91322 29.9679C3.93686 26.8503 3.73907 23.541 4.33715 20.3293C4.93522 17.1176 6.31094 14.1013 8.34404 11.5441C10.3771 8.98686 13.0057 6.96664 16 5.66M44 24C44 21.3736 43.4826 18.7728 42.4775 16.3463C41.4725 13.9198 39.9993 11.715 38.1421 9.85786C36.2849 8.00069 34.0801 6.5275 31.6536 5.52241C29.2271 4.51732 26.6264 4 24 4V24H44Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="35"
      height="39"
      viewBox="0 0 35 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 13.5002H33.5M1.5 25.5002H33.5M13.5 1.50024L9.5 37.5002M25.5 1.50024L21.5 37.5002"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.0001 4L38.0001 8M38.0001 8L44.0001 14L37.0001 21L31.0001 15M38.0001 8L31.0001 15M22.7801 23.22C23.8127 24.2389 24.6337 25.4521 25.1956 26.7896C25.7575 28.1271 26.0493 29.5625 26.0541 31.0133C26.059 32.464 25.7768 33.9014 25.2239 35.2426C24.671 36.5838 23.8582 37.8025 22.8324 38.8283C21.8065 39.8541 20.5879 40.6669 19.2467 41.2198C17.9054 41.7728 16.4681 42.0549 15.0173 42.0501C13.5666 42.0452 12.1311 41.7534 10.7936 41.1915C9.45614 40.6296 8.24299 39.8087 7.22406 38.776C5.22032 36.7014 4.11158 33.9228 4.13665 31.0386C4.16171 28.1544 5.31857 25.3955 7.35806 23.356C9.39755 21.3165 12.1565 20.1596 15.0406 20.1346C17.9248 20.1095 20.7034 21.2183 22.7781 23.222L22.7801 23.22ZM22.7801 23.22L31.0001 15"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26 4L6 28H24L22 44L42 20H24L26 4Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
